import { makeStyles, Theme } from "@material-ui/core";
import {
  centerItemFlex,
  customButtonStyle,
  mediumFont,
  getCurrentAccentColor,
  getCurrentAccentTextColor,
  lightGrey,
  darkGrey,
} from "../../../utils/styles";

const customButtonStyles = makeStyles(
  (theme: Theme) => ({
    btnStyle: {
      ...customButtonStyle,
      ...mediumFont,
      width: "100%",
      zIndex: 2,
      // boxShadow: "5px 6px 5px 0px #00000029",
      backgroundColor: getCurrentAccentColor(),
      color: getCurrentAccentTextColor(),
      "&:hover": {
        backgroundColor: getCurrentAccentColor(),
        color: getCurrentAccentTextColor(),
      },
      ...centerItemFlex,
    },
    disabledBtnStyle: {
      ...customButtonStyle,
      ...mediumFont,
      width: "100%",
      // boxShadow: "5px 6px 5px 0px #00000029",
      backgroundColor: lightGrey,
      color: darkGrey,
      "&:hover": {
        backgroundColor: lightGrey,
        color: darkGrey,
      },
      ...centerItemFlex,
    },
    glydeGif: {
      padding: "5px",
      width: "15px",
      height: "15px",
    },
    loading: {
      width: "100%",
      ...centerItemFlex,
    },
  }),
  { index: 1 }
);

export default customButtonStyles;
